import script from "./VInputPhone.vue?vue&type=script&setup=true&lang=js"
export * from "./VInputPhone.vue?vue&type=script&setup=true&lang=js"

import "./VInputPhone.vue?vue&type=style&index=0&id=d07f2880&lang=css&scoped=true"
import "./VInputPhone.vue?vue&type=style&index=1&id=d07f2880&lang=postcss&scoped=true"

import exportComponent from "/builds/frontend/dsp/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d07f2880"]])

export default __exports__